/**
 *
 * @module b-toolkit
 */
define('toolkit/b-toolkit/b-toolkit', [
	'jquery',
	'toolkit/b-toolkit/b-toolkit.core',
	'toolkit/b-toolkit/b-toolkit.context',
	'toolkit/b-toolkit/b-toolkit.cache',

	'toolkit-common/jquery/__fest/jquery__fest',
	'toolkit-common/jquery/__classList/jquery__classList',
	'toolkit-common/jquery/__event-fix/jquery__event-fix',
	'toolkit-common/jquery/__event-tap/jquery__event-tap',
	'toolkit-common/jquery/__event-scroll/jquery__event-scroll',
	'toolkit-common/jquery/__event-mousewheel/jquery__event-mousewheel'
], function ($, Block, context, cache){
	'use strict';

	var toolkit = context,
		_rBEMName = /\b([\da-z-]+(?:__[\da-z-]+)*)/ig,
		_rBEMMods = /(?:\b|__)[a-z0-9\-]+[^_]_([a-z0-9\-]+)(?:_([a-z0-9\-]+))?/ig;

	toolkit.toggleAria = function ($el, mod, state){
		switch(mod) {
			case 'checked':
			case 'disabled':
			case 'expanded':
			case 'hidden':
			case 'invalid':
				$el[state ? 'attr' : 'removeAttr']('aria-'+mod, mod);
				// MAIL-51026
				// при установке disable ставиться и disable и aria-disable
				// а при откулючении удаляется только второе,
				// в итоге в FF не срабатывает события по нажатию
				// на кнопку из-за атрибута disable="disable"
				$el[state ? 'attr' : 'removeAttr'](mod, mod);
				break;
		}
	};

	toolkit.throttle = function (func, delayedTime, context) {
		var timer,
			last,
			args;

		return function() {
			var doJob;

			args = arguments;

			if (!timer || +new Date() - last >= delayedTime) {
				doJob = function() {
					clearTimeout(timer);
					timer = null;
					last = null;

					if (args) {
						func.apply(this, args);
						args = null;
						timer = setTimeout(doJob, delayedTime);
						last = +new Date();
					}
				}.bind(context || this);

				doJob();
			}
		};
	};

	toolkit.debounce = function(func, delayedTime, context) {
		var timer;

		return function() {
			clearTimeout(timer);
			timer = setTimeout(function(args) {
				func.apply(this, args);
			}.bind(context || this, arguments), delayedTime);
		};
	};

	toolkit.toggleMod = function ($el, mod, state){
		if( $el ){
			if( !$el.jquery ) $el = $($el);

			var evt = $.Event("toggleMod");

			evt.mod = mod;
			evt.modState = (state === undefined) ? !toolkit.hasMod($el, mod) : !!state;

			$el.trigger(evt);

			if(!evt.isDefaultPrevented()) {
				var name = ($el.attr('class')+'').match(_rBEMName);
				if( name ){
					if( ~name[0].indexOf('js') ) name.shift();
					$el.toggleClass(name[0] +'_'+ mod, evt.modState);

					toolkit.toggleAria($el, mod, evt.modState);
				}
			}
		}
	};

	toolkit.getBlock = function (el) {
		return $(el).getBlock();
	};

	$.fn.hasMod = function (mod){
		return	toolkit.hasMod(this[0], mod);
	};

	$.fn.toggleMod = function (mod, state){
		return	this.each(function (){
			toolkit.toggleMod(this, mod, state);
		});
	};

	$.fn.getMods = function() {
		return toolkit.getMods(this[0]);
	};

	$.fn.findBem = function (name) {
		return this.find('[data-bem="' + name + '"]');
	};

	$.fn.getBlock = function () {
		var uniqid = this[0] && this[0].__toolkit_uniqid;
		return cache.get(uniqid);
	};

	toolkit.getMods = function($el) {
		var mods = {};

		if( $el ){
			if( !$el.jquery ) {
				$el = $($el);
			}

			// Extract mods
			var className = $el.attr('class'), matches, mod;
			while( matches = _rBEMMods.exec(className) ){
				mod = matches[1];
				mods[mod] = matches[2] || true;
			}
		}

		return mods;
	};

	toolkit.hasMod = function(el, mod) {
		return toolkit.getMods(el)[mod] !== void 0;
	};

	toolkit.isDisabledElem = function (el){
		if( el && el.jquery ){
			el = el[0];
		}

		return	!el || !!($.attr(el, 'disabled') || $.attr(el, 'aria-disabled'));
	};

	toolkit.windowWidth = function() {
		return	window.innerWidth ?
			window.innerWidth
			: (document.documentElement ?
			(
				document.documentElement.clientWidth ||
				document.body &&
				document.body.clientWidth || 0
			)
			: 0)
			;
	};

	toolkit.windowHeight = function() {
		return	window.innerHeight ?
			window.innerHeight
			: (document.documentElement ?
			(document.documentElement.clientHeight ||
				document.body && document.body.clientHeight || 0)
			: 0)
			;
	};

	(function () {
		var width,
			height;

		$(function () {
			var $sample = $('<div>').css({
				'position': 'absolute',
				'width': '100px',
				'height': '100px',
				'overflow': 'scroll',
				'top': '-9999px'
			}).appendTo(document.body);

			width = $sample[0].offsetWidth - $sample[0].clientWidth;
			height = $sample[0].offsetHeight - $sample[0].clientHeight;

			$sample.remove();
		});

		toolkit.scrollbarWidth = function () {
			return width;
		};

		toolkit.scrollbarHeight = function () {
			return height;
		};
	})(toolkit);

	$(document).bind('mouseup drop rb-show', function (evt){
		var el = evt.target, meta = [], name, target;

		do {
			if( meta.id == null ){
				meta.id = $.attr(el, 'data-id') || null;

				if( (meta.id != null) && (target === void 0) ){
					target = el;
				}
			}

			name = (
				(el.__mnemo || $.attr(el, 'data-mnemo')) ||
				(el.__group || $.attr(el, 'data-group')) ||
				(el.__name || $.attr(el, 'data-name')) ||
				(el.__act || $.attr(el, 'data-act'))
			);

			if( name ){
				meta.push( name );
				if( target === void 0 ){
					target = el;
				}
			}
		} while( (el = el.parentNode) && (el !== document) );


		if( meta.length ){
			meta.reverse();

			if( meta.id != null ){
				meta.push(meta.id);
			}

			$.event.trigger('toolkitclick', {
				el: target,
				$el: $(target),
				id: meta.id,
				root: meta[0],
				name: meta.join('.'),
				chain: meta,
				last: meta[meta.length-1],
				eventType: evt.type
			});
		}
	});

	// Локализация
	var lang = toolkit.lang = {};
	lang.get = function (key) {
		var value = lang[key];

		if (value === void 0 && key.indexOf('.') !== -1) {
			key = key.split('.');
			value = lang[key[0]];

			if (value) {
				for (var i = 1, n = key.length; i < n; i++) {
					value = value[key[i]];
					if (value == null) {
						return '';
					}
				}
			}
		}

		return value == null ? '' : value;
	};

	// шрифты
	toolkit.initUsingFonts();

	return toolkit;
});
